module.exports = __webpack_public_path__ + "static/media/banner_code.48ad586b.png";